'use client';

import React from 'react';
import Image from 'next/image';
import { getOrgMetaClient } from '@/config/client';
import { getRuntimeOrg, imageSrc } from '@/utils/runtimeOrg';

const ErrorMark: React.FC = () => {
  const meta = getOrgMetaClient(getRuntimeOrg());

  if (!meta.favicon) return null;

  return (
    <Image
      src={imageSrc(meta.favicon)}
      alt=""
      aria-hidden="true"
      width={72}
      height={72}
      priority
      className="h-[72px] w-[72px] object-contain grayscale"
    />
  );
};

export default ErrorMark;
